import {
  useState,
  useEffect,
  useRef,
  useLayoutEffect,
  useCallback,
} from "react";
import { useParams, useNavigate } from "react-router-dom";
import Categories from "../Categories/Categories";
import "../../index.css";
import { getFilteredPets } from "../../utils";
import SkeletonCards from "./SkeletonCards";
import { useSelector } from "react-redux";
import moment from "moment";
import Pets from "./Pets";
import Pagination from "./Pagination";
import { getAuth } from "firebase/auth";

const Buscador = ({ state }) => {
  const [pets, setPets] = useState([]);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = state !== "4" ? 11 : 12;
  const lastPostIndex = currentPage * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;
  const currentPets = pets.slice(firstPostIndex, lastPostIndex);
  const [actualDate, setActualDate] = useState("");
  const [catEdad, setCatEdad] = useState("");
  const [loading, setLoading] = useState(true);
  const [radio, setRadio] = useState(2000);
  const { lat, lng } = useParams();
  const auth = getAuth();

  const [formData, setFormData] = useState({
    contacto: "",
    tamano: "",
    fecha_perdido: "",
    sexo: "",
    tipo: "",
    raza: "",
    color: "",
    estado: state,
    Cachorro: { min: 0, max: 4 },
    Joven: { min: 5, max: 8 },
    Anciano: { min: 9, max: 16 },
    lat: lat || "",
    lng: lng || "",
  });

  const handleRadioChange = (newRadio, newLat, newLng) => {
    setRadio(newRadio);
    setFormData((prevFormData) => ({
      ...prevFormData,
      lat: newLat,
      lng: newLng,
    }));
  };

  const petFormDataState = useSelector((state) => state.compartirMascota);
  const [estadoName, setEstadoName] = useState("");
  const queryString = new URLSearchParams(formData).toString();

  const bgSearch = {
    1: ["bg-[#f24a4a]", "#f24a4a"],
    2: ["bg-[#f2c200]", "#f2c200"],
    3: ["bg-[#76a9d2]", "#76a9d2"],
    4: ["bg-[#7acf84]", "#7acf84"],
  };

  const hexColor = bgSearch[state][1] || "";

  useEffect(() => {
    const dataView = () => {
      if (state) {
        const estado = petFormDataState.estado.find(
          (r) => r.id.toString() === state
        );

        if (estado) {
          switch (estado.nombre) {
            case "Buscando":
              setEstadoName("Amigos Perdidos");
              break;
            case "Adopcion":
              setEstadoName("Amigos En adopción");
              break;
            case "Encontrado":
              setEstadoName("Amigos Encontrados");
              break;
            default:
              setEstadoName(estado.nombre);
          }
        } else {
          setEstadoName("");
        }
      }

      const currentDate = moment().format("YYYY-MM-DD");
      setActualDate(currentDate);
    };

    dataView();
  }, [state, petFormDataState]);

  const handleChange = (event) => {
    const { name, value, type } = event.target;

    if (type === "radio" && event.target.checked) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    } else if (name === "edad") {
      // Mapeo la categoría seleccionada al valor máximo
      const edadCategories = {
        Cachorro: 4,
        Joven: 8,
        Anciano: 16,
      };

      const maxAge = edadCategories[value] || "";

      setCatEdad(value); // Mantengo la categoría para usarla en el filtro
      setFormData((prevData) => ({
        ...prevData,
        edad: maxAge, // Guardo el max val de la categoria seleccionada en formData
      }));
    } else if (type === "date") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]:
          type === "number" || (!isNaN(value) && value.trim() !== "")
            ? parseInt(value)
            : value,
      }));
    }
  };

  const handleFilter = async () => {
    let formattedDate = formData.fecha_perdido;

    const petData = await getFilteredPets(
      formData,
      radio,
      catEdad,
      formattedDate,
      actualDate
    );
    setPets(petData);
  };

  useEffect(() => {
    const fetchFilteredPets = async () => {
      handleFilter();
      setLoading(false);
    };
    const timerId = setTimeout(fetchFilteredPets, 800);

    return () => clearTimeout(timerId);
  }, [formData, radio, catEdad]);

  const containerRef = useRef(null);
  const [isNarrow, setIsNarrow] = useState(false);

  useLayoutEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        setIsNarrow(containerRef.current.offsetWidth <= 636);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Estados y funciones para el modal/filtros
  const [showModal, setShowModal] = useState(false);
  const [scrollToEmptyFunction, setScrollToEmptyFunction] = useState(null);
  const [showEmptyBorders, setShowEmptyBorders] = useState(false);

  // Con esto veo si hay al menos algun filtro puesto
  const hasActiveFilters = useCallback(() => {
    return (
      formData.tipo ||
      formData.sexo ||
      formData.fecha_perdido ||
      formData.raza ||
      formData.color ||
      formData.tamano ||
      catEdad ||
      (formData.lat && formData.lng)
    );
  }, [formData, catEdad]);

  const handleScrollToEmpty = useCallback((scrollFunction) => {
    setScrollToEmptyFunction(() => scrollFunction);
  }, []);

  const handleAddFilter = useCallback(() => {
    setShowModal(false); // Cierra el modal
    setShowEmptyBorders(true); // Activa los bordes naranjas
    scrollToEmptyFunction();
  }, [scrollToEmptyFunction]);

  const handleCreatePublication = useCallback(() => {
    if (!auth.currentUser) {
      navigate("/sign-in");
      return;
    }
    if (hasActiveFilters()) {
      const newFormData = { ...formData };
      if (state === "3") {
        newFormData.estado = 1;
      } else if (state === "1") {
        newFormData.estado = 3;
      }
      const newQueryString = new URLSearchParams(newFormData).toString();
      navigate(`/compartir?${newQueryString}`);
    } else {
      setShowModal(true);
    }
  }, [hasActiveFilters, navigate, queryString]);

  return (
    <main>
      {showModal && (
        <div className="fixed inset-0 z-30 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-8 max-w-md w-full shadow-lg text-center">
            <h2 className="font-main text-2xl mb-4 text-orange-600">
              ¡Antes de continuar!
            </h2>
            <p className="font-main mb-4 text-gray-700">
              Te recomendamos primero completar los filtros de la izquierda con
              los datos de la mascota. Así, cuando creemos la publicación, esos
              datos se pasarán automáticamente y ahorrarás tiempo.
            </p>
            <button
              className="bg-orange-500 text-white px-6 py-2 rounded font-main  hover:bg-orange-700 transition"
              onClick={handleAddFilter}
            >
              Agregar filtro
            </button>
            <button
              className="font-main  ml-4 text-gray-500 hover:text-gray-800"
              onClick={() => {
                setShowModal(false);
                const newFormData = { ...formData };
                if (state === "3") {
                  newFormData.estado = 1;
                } else if (state === "1") {
                  newFormData.estado = 3;
                }
                const newQueryString = new URLSearchParams(
                  newFormData
                ).toString();
                navigate(`/compartir?${newQueryString}`);
              }}
            >
              Crear publicación
            </button>
          </div>
        </div>
      )}

      <div className="flex flex-col relative pt-6 bg-orange-5 0 pb-10">
        <div className="w-full md:px-[15dvw] px-8 sm:px-0 flex flex-col gap-5 items-center ">
          <h1 className="text-4xl sm:text-4xl uppercase text-center font-main text-white z-10 font-semibold">
            {estadoName}
          </h1>

          <div
            ref={containerRef}
            className="flex bg-white p-4 rounded-lg sm:rounded-none w-full z-10"
          >
            <div
              className={`sidebar h-full transition-all duration-300 ${
                isNarrow ? "w-0" : "min-[310px]:w-0"
              }`}
            >
              <Categories
                state={state}
                handleChange={handleChange}
                formData={formData}
                handleFilter={handleFilter}
                lat={formData.lat}
                lng={formData.lng}
                onRadioChange={handleRadioChange}
                onScrollToEmpty={handleScrollToEmpty}
                showEmptyBorders={showEmptyBorders}
                catEdad={catEdad} // Pasa catEdad como prop
              />
            </div>

            <div className="h-full flex-1 flex z-10 flex-col w-full">
              {loading ? (
                <SkeletonCards />
              ) : (
                <div className="w-full min-h-[1240px] flex flex-col justify-between gap-4 ">
                  <div className="grid gap-[8px] grid-cols-[repeat(auto-fit,minmax(340px,1fr))] justify-items-center">
                    <Pets pets={currentPets} />

                    {state !== "4" && (
                      <div
                        className="card-restantes transition-transform hover:scale-[102%] shadow-2xl pet-card-size rounded-lg cursor-pointer"
                        onClick={handleCreatePublication}
                      >
                        <div className="h-full rounded-lg bg-orange-500 flex flex-col justify-center">
                          <div className="rounded-t-lg pt-2 flex items-center justify-center">
                            <img
                              src="/catw.webp"
                              alt="Logo"
                              width={200}
                              height={190}
                            />
                          </div>
                          <div className="text-center font-main text-2xl font-bold text-white px-2 pt-4">
                            {state === "3"
                              ? "¿Perdiste a tu amigo?"
                              : "¿Encontraste un amigo perdido?"}
                          </div>
                          <div className="rounded-b-lg text-center font-main text-2xl font-bold text-white pt-2 px-2">
                            {state === "3"
                              ? "¡Te ayudaremos a encontrarlo!"
                              : "¡Ayudanos a encontrar sus dueños!"}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="w-full h-fit flex items-center justify-center">
                    <div className="flex gap-2 text-center">
                      <Pagination
                        totalPosts={pets.length}
                        postsPerPage={postsPerPage}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="w-screen absolute -top-[100px] left-0 overflow-hidden">
          <svg
            width="100%"
            height="100%"
            id="svg"
            viewBox="0 0 1440 490"
            xmlns="http://www.w3.org/2000/svg"
            className="transition duration-300 ease-in-out delay-150 w-[270%] md:w-[100%]"
          >
            <path
              d="M 0,500 L 0,93 C 56.27435897435893,109.58461538461539 112.54871794871787,126.16923076923078 203,127 C 293.45128205128213,127.83076923076922 418.0794871794873,112.9076923076923 500,99 C 581.9205128205127,85.0923076923077 621.1333333333333,72.2 684,63 C 746.8666666666667,53.8 833.3871794871797,48.2923076923077 927,58 C 1020.6128205128203,67.7076923076923 1121.3179487179486,92.63076923076922 1208,101 C 1294.6820512820514,109.36923076923078 1367.3410256410257,101.1846153846154 1440,93 L 1440,500 L 0,500 Z"
              stroke="none"
              strokeWidth="0"
              fill={hexColor}
              fillOpacity="0.4"
              className="transition-all duration-300 ease-in-out delay-150 path-0"
              transform="rotate(-180 720 250)"
            ></path>
            <path
              d="M 0,500 L 0,218 C 70.46923076923076,227.3230769230769 140.93846153846152,236.64615384615382 226,230 C 311.0615384615385,223.35384615384618 410.71538461538466,200.73846153846156 488,203 C 565.2846153846153,205.26153846153844 620.1999999999999,232.4 694,228 C 767.8000000000001,223.6 860.4846153846156,187.66153846153847 954,181 C 1047.5153846153844,174.33846153846153 1141.8615384615382,196.95384615384614 1223,208 C 1304.1384615384618,219.04615384615386 1372.069230769231,218.52307692307693 1440,218 L 1440,500 L 0,500 Z"
              stroke="none"
              strokeWidth="0"
              fill={hexColor}
              fillOpacity="0.53"
              className="transition-all duration-300 ease-in-out delay-150 path-1"
              transform="rotate(-180 720 250)"
            ></path>
            <path
              d="M 0,500 L 0,343 C 73.82820512820513,328.35128205128206 147.65641025641025,313.70256410256417 218,327 C 288.34358974358975,340.29743589743583 355.2025641025641,381.5410256410256 446,388 C 536.7974358974359,394.4589743589744 651.5333333333332,366.1333333333334 748,360 C 844.4666666666668,353.8666666666666 922.6641025641027,369.92564102564097 1001,363 C 1079.3358974358973,356.07435897435903 1157.8102564102564,326.1641025641026 1231,319 C 1304.1897435897436,311.8358974358974 1372.0948717948718,327.41794871794866 1440,343 L 1440,500 L 0,500 Z"
              stroke="none"
              strokeWidth="0"
              fill={hexColor}
              fillOpacity="1"
              className="transition-all duration-300 ease-in-out delay-150 path-2"
              transform="rotate(-180 720 250)"
            ></path>
          </svg>
        </div>
      </div>
    </main>
  );
};

export default Buscador;
